import lazyLoading from './lazyLoading'
import DashboardLayout from '@layouts/Dashboard'
import AgencyGuard from './guards/agency-guard'

export default [
  {
    path: '/agency/',
    component: DashboardLayout,
    beforeEnter: AgencyGuard,
    redirect: { name: 'agency.businesses.index' },
    children: [
      {
        name: 'new-agency.dashboard',
        path: 'dashboard',
        component: lazyLoading('Agency/NewDesign/BusinessesIndex'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.businesses.index',
        path: 'businesses',
        component: lazyLoading('Agency/NewDesign/BusinessesIndex'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.customers.index',
        path: 'customers',
        component: lazyLoading('Agency/NewDesign/CustomersIndex'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.settings',
        path: 'settings',
        component: lazyLoading('Agency/NewDesign/Settings'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.embed',
        path: '/agency/widgets/embed',
        component: lazyLoading('Agency/NewDesign/Embed'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.sr-widget',
        path: '/agency/widgets/sr-widget',
        component: lazyLoading('Agency/NewDesign/SocialReviewEmbed'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.zensocial-widget',
        path: '/agency/widgets/zensocial-widget',
        component: lazyLoading('Agency/NewDesign/ZenSocialEmbed'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.sf-widget',
        path: '/agency/widgets/sf-widget',
        component: lazyLoading('Agency/NewDesign/SocialFusionEmbed'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.instagram-widget.index',
        path: 'instagram-widget',
        component: lazyLoading('Agency/NewDesign/InstaWidget'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.insta-stream-widget',
        path: '/agency/widgets/is-widget',
        component: lazyLoading('Agency/NewDesign/InstaStreamEmbed'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.widgets.index',
        path: 'google-stream-widgets',
        component: lazyLoading('Agency/NewDesign/GoogleStreamEmbed'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.business-subscriptions',
        path: 'business-subscriptions',
        component: lazyLoading('Agency/NewDesign/AgencySubscriptionIndex'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'new-agency.subscriptions',
        path: 'business-subscriptions-subscribed',
        component: lazyLoading('Agency/NewDesign/AgencySubscriptionList'),
        beforeEnter: AgencyGuard,
      },
    ],
  },
]
